import { Component, OnInit } from '@angular/core';
import { LottoService, MarketplaceService } from '@fgb/core';
import { firstValueFrom, zip } from 'rxjs';

@Component({
  selector: 'fgb-marketplace-page',
  templateUrl: './marketplace-page.component.html',
})
export class MarketplacePageComponent implements OnInit {
  constructor(
    private marketplaceService: MarketplaceService,
    private lottoService: LottoService
  ) {}

  ngOnInit() {
    firstValueFrom(zip(this.lottoService.fetchLottos(), this.marketplaceService.fetchMarketplaceItems()));
  }
}
